<template>
<div class="jobs_wrapper">
  <div :class="{'overlay_setting': isLoadingData}">
    <i :class="{'loadding_setting': isLoadingData}"></i>
  </div>
  <div v-if="!isLoadingData">
    <h1 class="jobs_page_title" v-bind:style="{ color: colorSetting.pageText }">
      <span v-for="(headingSetting, index) in headingSettings" :key="index">
        <template v-if="jobDetail[headingSetting.name] && jobResourceFields[headingSetting.name]">
          <span v-if="isPreviousItemHaveData(jobDetail, headingSetting.name, index, headingSettings[index ? index - 1: index].name, headingSettings)">
            /
          </span>
          <span v-if="jobResourceFields[headingSetting.name].name === 'company_id'">
            <span v-if="jobDetail[companyPublicSetting] === 1">
              <span v-if="companyData.name">
                {{ companyData.name }}
              </span>
              <span v-else>
                {{ searchJobLabelsProperty.NAME_COMPANY_UNREGISTER }}
              </span>
            </span>
            <span v-else>
              {{ searchJobLabelsProperty.NAME_COMPANY_PRIVATE }}
            </span>
          </span>
          <span v-else-if="jobResourceFields[headingSetting.name].type === 'free_email'">
              {{ jobDetail[headingSetting.name].data }}
          </span>
          <span v-else-if="jobResourceFields[headingSetting.name].type === 'url'">
            {{ jobDetail[headingSetting.name] }}
          </span>
          <span v-else-if="TYPE_OF_SINGLE_SELECT.includes(jobResourceFields[headingSetting.name].type) && jobResourceFields[headingSetting.name].master_name && jobResourceFields[headingSetting.name].name">
            {{ getSingleSelectValue(jobResourceFields[headingSetting.name].master_name, jobDetail[headingSetting.name]) }}
          </span>
          <span v-else-if="TYPE_OF_MULTI_SELECT.includes(jobResourceFields[headingSetting.name].type) && jobResourceFields[headingSetting.name].master_name && jobResourceFields[headingSetting.name].name">
            <span v-for="(value, index) in getMultiSelectValue(jobResourceFields[headingSetting.name].master_name, jobDetail[headingSetting.name])" :key="index">
              <span v-if="index !== 0">, </span>
              <span>{{ value }}</span>
            </span>
          </span>
          <span v-else-if="FORMAT_DATE.includes(jobResourceFields[headingSetting.name].type)">
            {{ getDatetimeString(jobResourceFields[headingSetting.name].type, jobDetail[headingSetting.name]) }}
          </span>
          <span v-else-if="jobResourceFields[headingSetting.name].name === 'staff_id'">
            {{ staffData.name }}
          </span>
          <span v-else-if="TYPE_OF_NUMBER.includes(jobResourceFields[headingSetting.name].type)">
            {{formatNumberByStep(jobDetail[headingSetting.name], jobResourceFields[headingSetting.name].step)}}
          </span>
          <span v-else>
            {{ jobDetail[headingSetting.name] }}
          </span>
          <span v-if="jobResourceFields[headingSetting.name].unit" class="ml-1" :class="{'label_unit_item_long': jobResourceFields[headingSetting.name].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': jobResourceFields[headingSetting.name].unit.length <= userConfig.UNIT_LENGTH}">{{ jobResourceFields[headingSetting.name].unit }}</span>
        </template>
      </span>
    </h1>

    <div class="jobs_detail_text" v-bind:style="{ color: colorSetting.pageText }"
         v-for="(bodySetting, index) in bodySettings" :key="index">
      <template v-if="jobDetail[bodySetting.name] && jobResourceFields[bodySetting.name]">
        <span v-if="jobResourceFields[bodySetting.name].name === 'company_id'">
          <span v-if="jobDetail[companyPublicSetting] === 1">
            <span v-if="companyData.name">
              {{ companyData.name }}
            </span>
            <span v-else>
              {{ searchJobLabelsProperty.NAME_COMPANY_UNREGISTER }}
            </span>
          </span>
          <span v-else>
            {{ searchJobLabelsProperty.NAME_COMPANY_PRIVATE }}
          </span>
        </span>
        <span v-else-if="jobResourceFields[bodySetting.name].type === 'free_email'">
          <a v-bind:style="{color: colorSetting.linkText}" :href="'mailto:' + jobDetail[bodySetting.name].data" >
            {{ jobDetail[bodySetting.name].data }}
          </a>
        </span>
        <span v-else-if="jobResourceFields[bodySetting.name].type === 'url'">
          <a v-bind:style="{color: colorSetting.linkText}" :href="jobDetail[bodySetting.name]" style="text-decoration: none" target="_blank">
            {{ jobDetail[bodySetting.name] }}
          </a>
        </span>
        <span v-else-if="TYPE_OF_SINGLE_SELECT.includes(jobResourceFields[bodySetting.name].type) && jobResourceFields[bodySetting.name].master_name && jobResourceFields[bodySetting.name].name">
          {{ getSingleSelectValue(jobResourceFields[bodySetting.name].master_name, jobDetail[bodySetting.name]) }}
        </span>
        <span v-else-if="TYPE_OF_MULTI_SELECT.includes(jobResourceFields[bodySetting.name].type) && jobResourceFields[bodySetting.name].master_name && jobResourceFields[bodySetting.name].name">
          <span v-for="(value, index) in getMultiSelectValue(jobResourceFields[bodySetting.name].master_name, jobDetail[bodySetting.name])" :key="index">
            <span v-if="index !== 0">, </span>
            <span>{{ value }}</span>
          </span>
        </span>
        <span v-else-if="FORMAT_DATE.includes(jobResourceFields[bodySetting.name].type)">
          {{ getDatetimeString(jobResourceFields[bodySetting.name].type, jobDetail[bodySetting.name]) }}
        </span>
        <span v-else-if="jobResourceFields[bodySetting.name].name === 'staff_id'">
          {{ staffData.name }}
        </span>
        <span v-else-if="TYPE_OF_NUMBER.includes(jobResourceFields[bodySetting.name].type)">
          {{formatNumberByStep(jobDetail[bodySetting.name], jobResourceFields[bodySetting.name].step)}}
        </span>
        <span class="pre-margin-bottom line_break_setting_text" v-else>{{ jobDetail[bodySetting.name] }}</span>
        <span v-if="jobResourceFields[bodySetting.name].unit" class="ml-1" :class="{'label_unit_item_long': jobResourceFields[bodySetting.name].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': jobResourceFields[bodySetting.name].unit.length <= userConfig.UNIT_LENGTH}">{{ jobResourceFields[bodySetting.name].unit }}</span>
      </template>
    </div>

    <template v-for="(category, cIndex) in categories">
      <template v-if="category && !category.categoryDeleted && !isEmptyCategory(cIndex)">
        <h2 class="jobs_category_title"
            v-bind:style="{color: colorSetting.pageText, borderLeftColor: colorSetting.keyColor}">
          {{ category.categoryName }}
        </h2>
        <div class="jobs_table_wrapper">
          <table class="jobs_detail_table">
            <tbody class="jobs_detail_table_body">
              <template v-for="(item, index) in category.item">
                <tr class="jobs_detail_table_rows" v-if="!item.resourceField[0].name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY) && jobDetail[item.resourceField[0].name] && ((item.resourceField[0].name === 'company_id' && jobDetail[companyPublicSetting] === 1) && companyData.name || item.resourceField[0].name !== 'company_id')"
                    v-bind:key="item.resourceField[0].name">
                  <th class="jobs_detail_table_head"
                      v-bind:style="[{ backgroundColor: colorSetting.subColor }, index === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                    <span v-bind:style="{ color: colorSetting.pageText }" class="setting_word_break">
                      {{ item.itemName }}
                    </span>
                  </th>
                  <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}">
                    <span v-if="item.resourceField[0].name === 'company_id'">
                      {{ companyData.name }}
                    </span>
                    <span v-else-if="item.resourceField[0].type === 'free_email'">
                      <a v-bind:style="{color: colorSetting.linkText}" :href="'mailto:' + jobDetail[item.resourceField[0].name].data">
                        {{ jobDetail[item.resourceField[0].name].data }}
                      </a>
                    </span>
                    <span v-else-if="item.resourceField[0].type === 'url'">
                      <a v-bind:style="{color: colorSetting.linkText}" :href="jobDetail[item.resourceField[0].name]" target="_blank">
                        {{ jobDetail[item.resourceField[0].name] }}
                      </a>
                    </span>
                    <span v-else-if="TYPE_OF_SINGLE_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                      {{ getSingleSelectValue(item.resourceField[0].master_name, jobDetail[item.resourceField[0].name]) }}
                    </span>
                    <span v-else-if="TYPE_OF_MULTI_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                      <span v-for="(value, index) in getMultiSelectValue(item.resourceField[0].master_name, jobDetail[item.resourceField[0].name])" :key="index">
                        <span v-if="index !== 0">, </span>
                        <span>{{ value }}</span>
                      </span>
                    </span>
                    <span v-else-if="FORMAT_DATE.includes(item.resourceField[0].type)">
                      {{ getDatetimeString(item.resourceField[0].type, jobDetail[item.resourceField[0].name]) }}
                    </span>
                    <span v-else-if="item.resourceField[0].name === 'staff_id'">
                      {{ staffData.name }}
                    </span>
                    <span class="white-space" v-else-if="item.resourceField[0].type === 'textarea'">{{ jobDetail[item.resourceField[0].name] }}</span>
                    <span v-else-if="TYPE_OF_NUMBER.includes(item.resourceField[0].type)">
                      {{formatNumberByStep(jobDetail[item.resourceField[0].name], item.resourceField[0].step)}}
                    </span>
                    <span v-else>{{ jobDetail[item.resourceField[0].name] }}</span>
                    <span v-if="item.resourceField[0].unit" class="ml-1" :class="{'label_unit_item_long': item.resourceField[0].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': item.resourceField[0].unit.length <= userConfig.UNIT_LENGTH}">{{ item.resourceField[0].unit }}</span>
                  </td>
                </tr>
                <tr class="jobs_detail_table_rows" v-if="item.resourceField[0].name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY) && companyData[item.resourceField[0].name.substring(8)] && jobDetail[companyPublicSetting] === 1"
                    v-bind:key="item.resourceField[0].name">
                  <th class="jobs_detail_table_head"
                      v-bind:style="[{ backgroundColor: colorSetting.subColor }, index === 0 ? { border: '1px solid' + colorSetting.borderColor } : {borderLeft: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}]">
                    <span v-bind:style="{ color: colorSetting.pageText }" class="setting_word_break">
                      {{ item.itemName }}
                    </span>
                  </th>
                  <td class="jobs_detail_table_cell word-break" v-bind:style="{borderTop: '1px solid' + colorSetting.borderColor, borderRight: '1px solid' + colorSetting.borderColor, borderBottom: '1px solid' + colorSetting.borderColor}">
                    <span v-if="item.resourceField[0].type === 'free_email'">
                      <a v-bind:style="{color: colorSetting.linkText}" :href="'mailto:' + companyData[item.resourceField[0].name.substring(8)].data">
                        {{ companyData[item.resourceField[0].name.substring(8)].data }}
                      </a>
                    </span>
                    <span v-else-if="item.resourceField[0].type === 'url'">
                      <a v-bind:style="{color: colorSetting.linkText}" :href="companyData[item.resourceField[0].name.substring(8)]" target="_blank">
                        {{ companyData[item.resourceField[0].name.substring(8)] }}
                      </a>
                    </span>
                    <span v-else-if="TYPE_OF_SINGLE_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                      {{ getSingleSelectValue(item.resourceField[0].master_name, companyData[item.resourceField[0].name.substring(8)]) }}
                    </span>
                    <span v-else-if="TYPE_OF_MULTI_SELECT.includes(item.resourceField[0].type) && item.resourceField[0].master_name && item.resourceField[0].name">
                      <span v-for="(value, index) in getMultiSelectValue(item.resourceField[0].master_name, companyData[item.resourceField[0].name.substring(8)])" :key="index">
                        <span v-if="index !== 0">, </span>
                        <span>{{ value }}</span>
                      </span>
                    </span>
                    <span v-else-if="FORMAT_DATE.includes(item.resourceField[0].type)">
                      {{ getDatetimeString(item.resourceField[0].type, companyData[item.resourceField[0].name.substring(8)]) }}
                    </span>
                    <span class="white-space" v-else-if="item.resourceField[0].type === 'textarea'">{{ companyData[item.resourceField[0].name.substring(8)] }}</span>
                    <span v-else-if="TYPE_OF_NUMBER.includes(item.resourceField[0].type)">
                      {{formatNumberByStep(companyData[item.resourceField[0].name.substring(8)], item.resourceField[0].step)}}
                    </span>
                    <span v-else-if="isObjectDataHasValue(companyData[item.resourceField[0].name.substring(8)])">{{ companyData[item.resourceField[0].name.substring(8)].data }}</span>
                    <span v-else>{{ companyData[item.resourceField[0].name.substring(8)] }}</span>
                    <span v-if="item.resourceField[0].unit" class="ml-1" :class="{'label_unit_item_long': item.resourceField[0].unit.length > userConfig.UNIT_LENGTH, 'label_unit_item': item.resourceField[0].unit.length <= userConfig.UNIT_LENGTH}">{{ item.resourceField[0].unit }}</span>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </template>
    </template>

    <div class="jobs_btn_box" v-if="commonSetting">
      <button v-if="commonSetting.jobInquiryUrl" class="jobs_btn_primary" @click="redirectToContact"
              v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}">
        <span v-if="button.contactBtn === ''">
          {{ searchJobLabelsProperty.BUTTON_CONTACT }}
        </span>
        <span v-else>
          {{ button.contactBtn }}
        </span>
      </button>
      <button v-if="commonSetting.entryPublic" class="jobs_btn_primary" @click="applyJob"
              v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}">
        <span v-if="button.detailBtn === ''">
          {{ searchJobLabelsProperty.BUTTON_APPLY_JOB }}
        </span>
        <span v-else>
          {{ button.detailBtn }}
        </span>
      </button>
    </div>
    <div class="jobs_detail_back">
      <button class="jobs_btn_secondary jobs_btn_medium" @click="returnToSearchTop"
              v-bind:style="{color: colorSetting.subButtonText, backgroundColor: colorSetting.subButton, border: '1px solid' + colorSetting.borderColor,}">
        {{ searchJobLabelsProperty.RETURN_JOB_SEARCH_TOP }}
      </button>
    </div>
  </div>
  <div class="setting_botton_top" ref="ref_botton_top">
    <button v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}" class="setting_btn_primary" @click="onTopPage">
      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 320 512" height="1em" width="1em"><path d="M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z"></path></svg>
    </button>
  </div>
  <div class="setting_btn_print" v-if="isDisplayPrint">
    <button v-bind:style="{color: colorSetting.mainButtonText, backgroundColor: colorSetting.mainButton, border: '1px solid' + colorSetting.borderColor}" class="setting_btn_primary" @click="printPage()">
      <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect></svg>
    </button>
  </div>
</div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import userService from "../../services/UserService";
import commonSettingsProperties from "../../properties/common_screen/common-settings.json";
import formSettingService from "../../services/FormSettingService";
import masterSettingService from "../../services/MasterSettingsService";
import jobSettingService from "../../services/JobSettingService";
import searchJobLabelsProperty from "../../properties/user_search_job_screen/search-job-labels.json";
import jobSettingProperty from "../../properties/job_screen/job-screen.json";
import userConfig from "../../properties/user_entry_screen/config.json";
import authService from "../../services/AuthService";
import Utils from "../../Utils";
Vue.use(VueToast);

const DETAIL_FORM_TYPE = 2;
const SEARCH_FORM_TYPE = 1;
const COMPANY_FORM_TYPE = 3;
const HEADING_SETTING_TYPE = 0;
const BODY_SETTING_TYPE = 1;
const SEARCH_BUTTON_TYPE = 0;
const LIST_BUTTON_TYPE = 1;
const DETAIL_BUTTON_TYPE = 2;
const CONTACT_BUTTON_TYPE = 3;

export default {
  name: "DetailJobPage",
  props: [
    "encryptJobCode",
    "groupName",
    "commonSetting",
    "encryptEntryCode",
    "hash",
    "TYPE_OF_SINGLE_SELECT",
    "TYPE_OF_MULTI_SELECT",
    "FORMAT_DATE",
    "TYPE_OF_NUMBER",
    "getDatetimeString",
    "formatNumberByStep",
    "isPreviousItemHaveData",
    "isObjectDataHasValue",
    "isDisplayPrint"
  ],
  data() {
    return {
      jobId: -1,
      jobDetail: {},
      detailSettings: {},
      bodySettings: [],
      headingSettings: [],
      categories: [],
      masters: [],
      button: {
        searchBtn: "",
        listBtn: "",
        detailBtn: "",
        contactBtn: ""
      },
      colorSetting: {},
      companyData: {},
      staffData: {},
      companyPublicSetting: "",
      companySettings: {},
      companyResources: [],
      jobResourceFields: {},
      commonSettingsProperties: commonSettingsProperties,
      searchJobLabelsProperty: searchJobLabelsProperty,
      jobSettingProperty: jobSettingProperty,
      formSettingService: formSettingService,
      userConfig: userConfig,
      isLoadingData: false,
      timer: false,
      keyRedisSearch: ""
    };
  },

  async created() {
    this.isLoadingData = true;
    await this.getPageStatus();
    document.title = searchJobLabelsProperty.DETAIL_PAGE_TITLE;
    this.jobId = Number(this.$route.query.jid);
    this.keyRedisSearch = this.$route.query.query;
    await this.getJobResourceFields(this.hash);
    await this.getMasters(true, this.hash);
    await this.getJobDetailData(this.jobId, this.hash);
    await this.getJobDetailSettings(DETAIL_FORM_TYPE, this.hash);
    await this.getCompanyResourceSettings(this.hash);
    document.body.style.backgroundColor = this.colorSetting.pageBackground ? this.colorSetting.pageBackground :"#FFFF";
    this.loadResized();
    document.body.addEventListener('scroll', (e) => {
      if (this.$refs.ref_botton_top) {
        this.$refs.ref_botton_top.style.display = "none";
        if (e.target.scrollTop > 20) {
          this.$refs.ref_botton_top.style.display = "block";
        }
      }
    });
  },

  updated() {
    this.resetHeightIframe();
    window.onresize = () => {
      this.loadResized();
    };
  },

  methods: {
    loadResized() {
      if (this.timer !== false) {
        clearTimeout(this.timer);
      }

      this.timer = setTimeout(this.resetHeightIframe(), 200);
      let windowWidth = window.innerWidth;
      document.body.className = (windowWidth >= 768) ? "scroll-bar print-body-pc": "scroll-bar";
    },

    resetHeightIframe() {
      let elementResize = document.getElementById("resize_iframe");
      if (window.parent && elementResize) {
        let heightPage = elementResize.clientHeight;
        window.parent.postMessage(["resized", {height: heightPage}], "*");
      }
    },

    async redirectToContact() {
      await this.$emit("createLogger", "Detail job page user - Click button " + (this.button.contactBtn ? this.button.contactBtn : searchJobLabelsProperty.BUTTON_CONTACT));
      window.open(this.commonSetting.jobInquiryUrl, "_blank");
    },

    async returnToSearchTop() {
      await this.$emit("createLogger", "Detail job page user - Click button " + searchJobLabelsProperty.RETURN_JOB_SEARCH_TOP);
      window.location = window.location.origin + "?c=" + encodeURIComponent(this.encryptJobCode) + "&query=" + encodeURIComponent(this.keyRedisSearch);
      this.onTopOfIframe();
    },

    async applyJob() {
      await this.$emit("createLogger", "Detail job page user - Click button " + (this.button.detailBtn ? this.button.detailBtn : searchJobLabelsProperty.BUTTON_APPLY_JOB) + " width id: " + this.jobId);
      if (this.encryptEntryCode !== "") {
        window.location = window.location.origin + "?c=" + encodeURIComponent(this.encryptEntryCode) + `&jid=${this.jobId}`+ "&query=" + encodeURIComponent(this.keyRedisSearch) + `&jt=${DETAIL_FORM_TYPE}`;
      }
      this.onTopOfIframe();
    },

    onTopOfIframe() {
      window.parent.postMessage(["onTopIframe", {}], "*");
    },

    async getJobDetailData(jobId, hash) {
      await userService.getJobDetail(jobId, hash).then(jobResponse => {
        this.jobDetail = jobResponse.data;
        this.getCompanyData(jobResponse.data.company_id, hash);
        this.getStaff(jobResponse.data.staff_id, hash);
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      });
    },

    async getCompany(companyId) {
      if (!companyId) {
        return;
      }

      await userService.getCompany(companyId, "").then(companyResponse => {
        this.companyData = companyResponse.data;
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      });
    },

    async getJobDetailSettings(type, hash) {
      await formSettingService.getFormSettingByType(type, hash).then(async response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }

        this.detailSettings = response.data;
        this.colorSetting = this.detailSettings.customizeSetting;
        this.handleInputBtn();
        this.handleInputBodyHeadingSetting();
        this.handleInputItemResources();
        await this.getCompanyPublicSetting(hash);
        this.handleUpdateDisplayPrint(response.data.displaySetting);
      }).catch(e => {
        console.log(e);
      });
    },
    
    handleUpdateDisplayPrint(displaySetting){
      let settingPrint = displaySetting && displaySetting.print ? displaySetting.print: false;
      this.$emit("syncCheckDisplayPrint", settingPrint);
    },

    handleInputBtn() {
      this.detailSettings.buttonSetting.forEach(btn => {
        switch (btn.buttonType) {
          case SEARCH_BUTTON_TYPE: {
            this.button.searchBtn = btn.buttonName;
            break;
          }
          case LIST_BUTTON_TYPE: {
            this.button.listBtn = btn.buttonName;
            break;
          }
          case DETAIL_BUTTON_TYPE: {
            this.button.detailBtn = btn.buttonName;
            break;
          }
          case CONTACT_BUTTON_TYPE: {
            this.button.contactBtn = btn.buttonName;
            break;
          }
        }
      });
    },

    handleInputBodyHeadingSetting() {
      this.headingSettings = [];
      this.bodySettings = [];
      this.detailSettings.bodyHeadingSetting.forEach(setting => {
        if (setting.type === HEADING_SETTING_TYPE) {
          this.headingSettings.push(setting);
        }

        if (setting.type === BODY_SETTING_TYPE) {
          this.bodySettings.push(setting);
        }
      });
    },

    handleInputItemResources() {
      this.categories = [];
      this.detailSettings.categorySetting.forEach(category => {
        this.categories.push(category);
      });
    },

    async getCompanyPublicSetting(hash) {
      await formSettingService.getFormSettingByType(SEARCH_FORM_TYPE, hash).then(response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }

        this.companyPublicSetting = response.data.displaySetting.companyPublicSetting;
      }).catch(e => {
        console.log(e);
      });
    },

    getCompanyResourceSettings(hash) {
      formSettingService.getFormSettingByType(COMPANY_FORM_TYPE, hash).then(response => {
        if (!response || !response.data || !response.data.id) {
          return;
        }

        this.companySettings = response.data;
        this.handleInputCom0anyResources();
      }).catch(e => {
        console.log(e);
      }).finally(() => {
        this.isLoadingData = false;
      })
    },

    handleInputCom0anyResources() {
      this.companyResources = [];
      this.companySettings.categorySetting.item.forEach(item => {
        this.companyResources.push(item);
      });
    },

    getCompanyData(companyId, hash) {
      userService.getCompany(companyId, hash).then(companyResponse => {
        this.companyData = companyResponse.data;
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      });
    },

    getSingleSelectValue(key, value) {
      if (!key || !value) {
        return "";
      }
      if (this.masters.length <= 0 || !this.masters[key] || !this.masters[key].items) {
        return "";
      }
      let item = this.masters[key].items.find(item => item.choiceId === value);
      let itemValue = "";
      if (item) {
        itemValue = item.choiceDisplayName ? item.choiceDisplayName: item.choiceName;
      }
      return itemValue;
    },

    getMultiSelectValue(key, values) {
      let itemValues = [];
      if (!key || !values || values.length === 0) {
        itemValues.push("");
        return itemValues;
      }

      if (this.masters.length <= 0 || !this.masters[key] || !this.masters[key].items) {
        itemValues.push("");
        return itemValues;
      }

      this.masters[key].items.filter(item => values.includes(item.choiceId)).forEach(item => {
        if (item.choiceDisplayName) {
          itemValues.push(item.choiceDisplayName);
        } else {
          itemValues.push(item.choiceName);
        }
      });

      return itemValues;
    },

    async getMasters(duplicate, hash) {
      await masterSettingService.getAll(duplicate, hash).then(response => {
        if (response && response.data != null) {
          this.masters = response.data;
        }
      }).catch(e => {
        console.log(e);
      });
    },

    async getJobResourceFields(hash) {
      let searchDto = {};
      searchDto.keyWord = "";
      await jobSettingService.getJobResourceField(searchDto, hash).then(response => {
        if (response && response.data != null) {
          this.jobResourceFields = response.data;
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      });
    },

    getStaff(staffId, hash) {
      if (!staffId) {
        return;
      }

      userService.getStaff(staffId, hash).then(response => {
        this.staffData = response.data
      }).catch(e => {
        console.log(e)
      })
    },

    isEmptyCategory(index) {
      if (this.categories[index].item.length === 0) {
        return true;
      }

      return this.categories[index].item.filter(item => {
        let isItemCompany = item.resourceField[0].name.startsWith(jobSettingProperty.ITEM_COMPANY_MODIFY);
        let isPublicCompany = this.jobDetail[this.companyPublicSetting] === 1;
        let isItemCompanyId = item.resourceField[0].name === 'company_id';
        let isHasCompanyData = (( isItemCompanyId && isPublicCompany) && this.companyData.name || !isItemCompanyId);
        return (!isItemCompany && this.jobDetail[item.resourceField[0].name] && isHasCompanyData)
        || (isItemCompany && this.companyData[item.resourceField[0].name.substring(8)] && isPublicCompany);
      }).length === 0;
    },

    onTopPage() {
      document.body.scrollTop = 0;
    },

    getPageStatus() {
      authService.getScreenStatus().then(screenStatusResponse => {
        if (Number(screenStatusResponse.data.is_iframe_application_job) !== 1) {
          this.$router.push("/404");
        }
      }).catch(e => {
        Utils.responsePageMaintenance(e);
      });
    },

    printPage() {
      this.$emit("printPage");
    }
  },
};
</script>

<style scoped>
.pre-margin-bottom {
  margin-bottom: 0 !important;
}

.overlay_setting {
  background-color: rgba(223, 222, 222, 0.6) !important;
}

.line_break_setting_text {
  word-break: break-all;
  white-space: pre-wrap;
}

.setting_word_break {
  word-break: break-all;
}

.white-space {
  white-space: break-spaces;
}

.word-break {
  word-break: break-all;
}
.jobs_page_title{
  margin-bottom: 12px !important;
}

.label_unit_item {
  word-break: keep-all;
}

.label_unit_item_long {
  word-break: break-all !important;
  min-width: 50px;
}

.setting_botton_top{
  position: absolute;
  bottom: calc(100vh/4);
  right: 0.5rem;
  height: 50px;
  padding: 16px;
  display: none;
  z-index: 1;
  font-size: 120%;
  font-weight: bold;
}

.setting_btn_print{
  position: absolute;
  top: 0px;
  right: 0.5rem;
  height: 50px;
  padding: 16px;
  display: block;
  z-index: 1;
  font-size: 120%;
  font-weight: bold;
}
</style>
